/**
 * Removes <think></think> tags and their content from text
 * @param {string} text - The text to process
 * @returns {string} - Text with think tags removed and cleaned up
 */
export const removeThinkTags = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  // Remove <think>...</think> tags and their content using regex
  // This handles both single line and multiline think tags
  let processedText = text.replace(/<think>[\s\S]*?<\/think>/gi, '');
  
  // Remove any leading/trailing whitespace and normalize line breaks
  processedText = processedText.trim();
  
  // Remove excessive newlines at the beginning
  processedText = processedText.replace(/^[\r\n]+/, '');
  
  return processedText;
};

/**
 * Converts basic markdown to HTML for rendering
 * @param {string} text - The text to process
 * @returns {string} - Text with HTML markup
 */
export const convertMarkdownToHtml = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }

  let processedText = text;

  // Convert headings (### to h3, ## to h2, # to h1)
  processedText = processedText.replace(/^### (.*$)/gim, '<h3>$1</h3>');
  processedText = processedText.replace(/^## (.*$)/gim, '<h2>$1</h2>');
  processedText = processedText.replace(/^# (.*$)/gim, '<h1>$1</h1>');
  
  // Convert bold text (**text** to <strong>text</strong>)
  processedText = processedText.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  
  // Convert italic text (*text* to <em>text</em>)
  processedText = processedText.replace(/\*(.*?)\*/g, '<em>$1</em>');

  // Convert line breaks to <br> tags
  processedText = processedText.replace(/\n/g, '<br>');

  return processedText;
};

/**
 * Processes assistant response by removing think tags and converting markdown
 * @param {string} text - The raw response text
 * @returns {string} - Processed text ready for display
 */
export const processAssistantResponse = (text) => {
  // First remove think tags
  let processedText = removeThinkTags(text);
  
  // Then convert markdown to HTML
  processedText = convertMarkdownToHtml(processedText);
  
  return processedText;
};